// extracted by mini-css-extract-plugin
export default {"container":"mb0ia5xKVkdx16Lt8FLL","cursor":"wdLjNrEzXlsA6ChnbLBL","name":"QFbR2o5TazfY7twtthOD"};